import {createSlice} from "@reduxjs/toolkit";
import {saveProfileSuccess} from "store/reducer/user/profile/reducer";

export const initialState = {
    isEdit : false
};

const slice = createSlice({
    name: "profileEdit",
    initialState,
    reducers: {
        enableProfileEditMode: (state) => {
            state.isEdit = true;
        }
    },
    extraReducers: {
        [saveProfileSuccess]: (state) => {
            state.isEdit = false;
        }
    }
});

const {reducer, actions} = slice;

export const {
    enableProfileEditMode
} = actions;

export default reducer;